import React from 'react';
import '../../styles/services.css';
import { motion } from 'framer-motion';

const HumanResources = () => (
  <motion.div
    className="services-container"
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
  >
    <h1 className="services-title">Human Resources Services</h1>
    <p className="services-subtitle">
      Hire our expert developers, testers, DevOps engineers, designers, data experts, and AI/ML specialists 
      to achieve your short-term and long-term goals. Save costs without compromising on quality by 
      leveraging our skilled professionals.
    </p>

    <div className="services-grid">
      {/* Developers */}
      <div className="service-card">
        <h2>👨‍💻 Skilled Developers</h2>
        <p>
          Access experienced developers for project-based or long-term engagement without overhead costs.
        </p>
      </div>

      {/* Testers */}
      <div className="service-card">
        <h2>🧪 Testers</h2>
        <p>
          Ensure high-quality software with dedicated QA engineers for testing and validation.
        </p>
      </div>

      {/* DevOps */}
      <div className="service-card">
        <h2>⚙️ DevOps Engineers</h2>
        <p>
          Optimize workflows, automate deployments, and enhance system reliability with skilled DevOps engineers.
        </p>
      </div>

      {/* Designers */}
      <div className="service-card">
        <h2>🎨 UI/UX Designers</h2>
        <p>
          Deliver engaging and user-friendly experiences with our creative UI/UX design experts.
        </p>
      </div>

      {/* Data Experts */}
      <div className="service-card">
        <h2>📊 Data Experts</h2>
        <p>
          Leverage the expertise of <strong>Data Engineers</strong> to build robust pipelines and 
          <strong> Data Analysts</strong> to generate actionable insights, helping businesses make 
          data-driven decisions with confidence.
        </p>
      </div>

      {/* AI/ML */}
      <div className="service-card">
        <h2>🤖 AI & ML Specialists</h2>
        <p>
          Harness the power of Artificial Intelligence and Machine Learning to build intelligent, scalable solutions.
        </p>
      </div>
    </div>
  </motion.div>
);

export default HumanResources;
